module.exports = __webpack_public_path__ + "assets/webgl/card_063_DE_L0.3dcce12d.jpg";